export const API_TYPES = {
  /** Test Case Management v2 endpoints */
  TCM_V2: "tcm-v2",

  /** Job execution and management endpoints */
  JOB_RUNNER: "job-runner",

  JOB_SETTINGS: "job-settings",

  JOB_SUBMIT: "job-submit",

  /** Legacy v1 endpoints */
  V1_LEGACY: "v1-legacy",

  /** Authentication endpoints */
  AUTH: "auth",
  ACCESS_CONTROL: "access-control",

  /** CRUD endpoints for AWS Secrets**/
  AWS_SECRETS: "aws-secrets",

  /** Raise issue endpoints via jira apis**/
  JIRA_ISSUE: "jira",

  /** Tags related endpoints**/
  TAGS: "tags",

  /** Fetch repo files and folders**/
  VERSION_CONTROL_SYSTEM: "vcs",

  /** Fetch repo files and folders**/
  FILE_CACHE: "cache",

  /** Get project based configurations **/
  PROJECT_CONFIGS: "project-configs",

  /** Optics endpoints */
  OPTICS: "optics",

  /** Report generation endpoints */
  REPORTS: "reports",

  /** Session screenshot data endpoints */
  SESSION_SCREENSHOTS: "session-screenshots",

  CODEGEN: "codegen",

  DEVICES: "devices",

  BROWSERS: "browsers",

  TEST_STUDIO: "test-studio",
};

export const getBaseURL = (organization, apiType) => {
  switch (apiType) {
    case API_TYPES.TCM_V2: // used in generating a robot suite
      return `https://${organization}-api.mozark.ai/v2`;
    case API_TYPES.JOB_RUNNER:
      return `https://${organization}-api.mozark.ai/job-runner`;
    case API_TYPES.JOB_SETTINGS:
      return `https://${organization}-api.mozark.ai/v3/job-settings`;
    case API_TYPES.JOB_SUBMIT:
      return `https://${organization}-api.mozark.ai/v3/jobs`;
    case API_TYPES.V1_LEGACY:
      return `https://${organization}-api.mozark.ai/v1`;
    case API_TYPES.OPTICS:
      return `https://${organization}-optics-api.mozark.ai`;
    case API_TYPES.AUTH:
      return `${process.env.REACT_APP_AUTH_BASE_URL}/auth`;
    case API_TYPES.ACCESS_CONTROL:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/access-control`;
    case API_TYPES.AWS_SECRETS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/aws-secrets`;
    case API_TYPES.JIRA_ISSUE:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/jira`;
    case API_TYPES.VERSION_CONTROL_SYSTEM:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/vcs`;
    case API_TYPES.FILE_CACHE:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/cache`;
    case API_TYPES.PROJECT_CONFIGS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/project-configs`;
    case API_TYPES.TAGS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/tags`;
    case API_TYPES.REPORTS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/reports`;
    case API_TYPES.SESSION_SCREENSHOTS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/session-screenshots`;
    case API_TYPES.CODEGEN:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/codegen`;
    case API_TYPES.DEVICES:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/devices`;
    case API_TYPES.BROWSERS:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/browsers`;
    case API_TYPES.TEST_STUDIO:
      return `${process.env.REACT_APP_ORCHESTRATOR_BASE_URL}/test-studio`;
    default:
      throw new Error(`Unknown API type: ${apiType}`);
  }
};
